module.exports = __webpack_public_path__ + "img/Triangle.6740a5dd.svg";